import { graphql } from '@/gql';
import type { DownloadOperatorActivityReportsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const downloadOperatorActivityReports = async ({
  teamLeadId,
  startDate,
  endDate,
  status,
  statusType,
}: DownloadOperatorActivityReportsQueryVariables): Promise<string> => {
  const response = await queryExecute({
    query: graphql(`
      query DownloadOperatorActivityReports(
        $teamLeadId: String!
        $startDate: String!
        $endDate: String!
        $status: String
        $statusType: String
      ) {
        downloadOperatorActivityReports(
          teamLeadId: $teamLeadId
          startDate: $startDate
          endDate: $endDate
          status: $status
          statusType: $statusType
        )
      }
    `),
    variables: {
      teamLeadId,
      startDate,
      endDate,
      status,
      statusType,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.downloadOperatorActivityReports;
};
